/*
Controller: Ai

Operations:
  aiDescription
  createAiFeedback
  submitAiFeedback
*/
var Api = require('../config')
var AiDescriptionRequestDef = require('../definitions/AiDescriptionRequest')
var CreateAiFeedbackRequestDef = require('../definitions/CreateAiFeedbackRequest')
var PatchAiFeedbackRequestDef = require('../definitions/PatchAiFeedbackRequest')

var Ai = (function () {
  /*
  Operation: aiDescription
  Improving description using AI
  Parameters:

  Responses:
    HTTP 200: 
    HTTP 400: AI feedback update failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 429: AI rate limit exceeded
    HTTP 502: Bad Gateway
  */
  function aiDescriptionAi (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        AiDescriptionRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/ai/description'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createAiFeedback
  Create AI feedback record
  Parameters:
    bodyRequest: AI feedback create request
  Responses:
    HTTP 200: Success
    HTTP 400: AI feedback creation failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function createAiFeedbackAi (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        CreateAiFeedbackRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/ai/feedback'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: submitAiFeedback
  Submit feedback for AI suggestion
  Parameters:
    feedbackId: Id of AI feedback
    bodyRequest: AI feedback object
  Responses:
    HTTP 200: Success
    HTTP 400: AI feedback update failed
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: AI feedback not found
  */
  function submitAiFeedbackAi (feedbackId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!feedbackId) {
          throw new Error('feedbackId: Missing parameter')
        }
        if (feedbackId && !(typeof feedbackId === 'string')) {
          throw new Error('feedbackId: Wrong type: Got "' + (typeof feedbackId) + '", but expected: "string"')
        }
        PatchAiFeedbackRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/ai/feedback/{feedbackId}'
      path = path.replace('{' + 'feedbackId' + '}', feedbackId)
      Api
        .request({
          url: path,
          method: 'patch',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['aiDescription'] = aiDescriptionAi
  ret['createAiFeedback'] = createAiFeedbackAi
  ret['submitAiFeedback'] = submitAiFeedbackAi
  return ret
})()

module.exports = Ai
